<template>
  <div class="box">
    <div class="content">
       <div class="top-content" v-if="success=='true'">
          <div class="clear">
              <p class="tips">
                  <img src="../assets/img/correct.png" alt="" class="correct">
                  <span>支付成功，我们将尽快为您处理！</span>
              </p>
              <p class="order">订单号:{{orderId}}</p>
              <p class="money">支付金额: <span>￥{{price}}</span>元</p>
          </div>
           <div class="btn clear">
                <p class="buy" @click="finish">完成</p>
           </div>
       </div>
        <div class="top-content" v-if="success=='time'">
            <div class="clear">
                <p class="tips">
                    <img src="../assets/img/warning.png" alt="">
                    <span>抱歉，您的交易因超时已失败！</span>
                </p>
            </div>
            <div class="btn clear">
                <p class="buy" @click="goToIndex">返回首页</p>
            </div>
        </div>

    </div>
  </div>
</template>

<script>



export default {
    name: 'pay',
    components: {},
    data () {
        return {
            success:'true',
            url:'',
            indexUrl:'',
            price:'',
            orderId:'',
        }
    },
    methods: {
        goToIndex(){
            window.location.href  = this.indexUrl;
        },
        finish(){
            window.location.href  = this.url;
        },

    },
    mounted:function () {
        if(this.$route.query.success){
            this.success = this.$route.query.success;
        }
        if(this.$route.query.url){
            this.url = this.$route.query.url;
        }
        if(this.$route.query.indexUrl){
            this.indexUrl = this.$route.query.indexUrl;
        }
        if(this.$route.query.price){
            this.price = this.$route.query.price;
        }
        if(this.$route.query.orderId){
            this.orderId = this.$route.query.orderId;
        }
    }

}
</script>
<style scoped lang="scss">
    .box{
        background: #fff;
        width: 1170px;
        margin: 0 auto;
        margin-top: 36px;
        .pay-title{
            font-size:18px;
            font-weight:600;
            color:rgba(48,50,51,1);
            padding: 40px 40px 16px 40px;
            border-bottom: 1px solid rgba(237,240,242,1);
            text-align: left;
        }
        .content{
            padding: 40px;
            .top-content{
                padding-bottom: 20px;
                text-align: left;
                .tips{
                    margin-right: 24px;
                    font-size:18px;
                    font-weight:500;
                    color:rgba(48,50,51,1);
                    line-height:26px;
                    img{
                        width: 24px;
                        height: 24px;
                        vertical-align: middle;
                        margin-right: 8px;
                    }
                }
                .order{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(144,149,153,1);
                    line-height:24px;
                    margin:8px 0 12px 32px;
                }
                .money{
                    font-size:18px;
                    font-weight:500;
                    color:rgba(48,50,51,1);
                    line-height:26px;
                    margin-left: 32px;
                    span{
                        font-size:26px;
                        font-weight:normal;
                        color:rgba(245,34,45,1);
                        line-height:26px;
                        margin: 0 4px;
                    }
                }
                .btn{
                    margin-top: 40px;
                    margin-left: 32px;
                    .buy{
                        width:88px;
                        height:32px;
                        background:rgba(58,163,255,1);
                        border-radius:4px;
                        text-align: center;
                        line-height: 32px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        float: left;
                        margin-right: 24px;
                        cursor: pointer;
                    }
                    .return{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(58,163,255,1);
                        line-height:14px;
                        float: left;
                        margin-top: 9px;
                        cursor: pointer;
                    }
                }
            }

        }
    }

</style>
